// extracted by mini-css-extract-plugin
module.exports = {"slideUp":"keyframes-slideUp-LLvTy","fadeIn":"keyframes-fadeIn-1decM"};